{
  "bookmarks": {
    "framingFallback": "Position",
    "missingNode": "Deleted node",
    "nodeCount_one": "{{count}} node",
    "nodeCount_other": "{{count}} nodes",
    "errors": {
      "add": "Could not add the bookmark",
      "rename": "Could not rename the bookmark",
      "reorder": "Could not reorder the bookmarks",
      "remove": "Could not remove the bookmark"
    }
  },
  "speech": {
    "recordingUnsupported": "Audio recording is not supported by this browser.",
    "noSpeech": "No speech detected.",
    "transcriptionFailed": "Transcription failed. Please try again.",
    "liveUnavailable": "Live dictation is not available on this device.",
    "notConfigured": "Voice dictation is not configured.",
    "microphone": {
      "denied": "Microphone access denied. Allow the microphone in your browser settings.",
      "notFound": "No microphone detected.",
      "busy": "Microphone unavailable (already in use by another application?).",
      "overconstrained": "The microphone does not support the requested settings.",
      "unavailable": "Unable to access the microphone."
    },
    "server": {
      "badMessage": "Communication error with the voice server.",
      "idleTimeout": "Voice session closed due to inactivity.",
      "sessionTooLong": "Maximum dictation duration reached.",
      "upstreamError": "The transcription service is temporarily unavailable.",
      "backpressure": "Connection too slow for live dictation.",
      "shutdown": "The voice server is restarting, please try again in a moment.",
      "internal": "Internal voice server error.",
      "generic": "Voice server error.",
      "unreachable": "Could not reach the voice server. Try again in a few seconds.",
      "interrupted": "The connection to the voice server was interrupted.",
      "noAnswer": "The voice server did not answer, the dictation could not be transcribed.",
      "notResponding": "The voice server is not responding. Try again in a few seconds.",
      "noTranscript": "The voice server returned no transcript. Please try again."
    }
  },
  "nodes": {
    "cannotDuplicateType": "This node type can no longer be duplicated.",
    "framesInFrame": "Frames can't go inside a frame: only their content was added.",
    "someTypesCannotBePasted": "Some node types can no longer be pasted.",
    "someTypesCannotBeDuplicated": "Some node types can no longer be duplicated.",
    "addFailed_one": "Could not add the node",
    "addFailed_other": "Could not add the nodes",
    "updateFailed": "Error updating"
  },
  "nole": {
    "threadWithoutCanvas": "Cannot create a conversation without a canvas.",
    "sendFailed": "Could not send the message. Please try again.",
    "nothingToStop": "Nothing to stop: Nolë has already finished.",
    "stopFailed": "Could not stop the current answer",
    "switchModelFailed": "Could not switch the model of the running task",
    "newSessionFailed": "Could not start a new session."
  },
  "canvases": {
    "deleteFailed": "Error deleting canvas."
  },
  "canvasDrop": {
    "rowFailed": "Could not place the row on the canvas"
  },
  "edges": {
    "updateFailed": "Error updating edge",
    "addFailed": "Could not add the connection"
  },
  "history": {
    "nothingToUndo": "Nothing left to undo",
    "nothingToRedo": "Nothing left to redo",
    "undoFailed": "Could not undo",
    "redoFailed": "Could not redo"
  },
  "openSelection": {
    "truncated_one": "Opened the first {{max}} of {{count}} node",
    "truncated_other": "Opened the first {{max}} of {{count}} nodes"
  },
  "links": {
    "invalidUrl": "Invalid URL"
  },
  "databaseDrop": {
    "fallbackTitle": "the database",
    "addFailed": "Could not add the node to the database",
    "added_one": "Put in {{title}}.",
    "added_other": "{{count}} nodes put in {{title}}."
  },
  "transcription": {
    "startFailed": "Could not start the transcription"
  },
  "ingest": {
    "addedNamed": "{{label}} added to canvas",
    "nodesAdded_one": "{{count}} node added to canvas",
    "nodesAdded_other": "{{count}} nodes added to canvas",
    "filesFailed_one": "A file could not be added",
    "filesFailed_other": "{{count}} files failed",
    "imageAdded": "Image added to canvas",
    "linkAdded": "Link added to canvas",
    "documentCreated": "Document created"
  },
  "reveal": {
    "notFound": {
      "block": "Couldn't find this block: it was probably deleted.",
      "column": "Couldn't find this column: it was probably deleted.",
      "row": "Couldn't find this row: it was deleted, or the table's search or filters hide it.",
      "cell": "Couldn't find this cell: it was deleted, or the table's search or filters hide it."
    }
  },
  "copyIds": {
    "copied_one": "Node ID copied",
    "copied_other": "Node IDs copied",
    "failed": "Failed to copy IDs",
    "menu_one": "Copy ID",
    "menu_other": "Copy IDs",
    "nodeIds_one": "Node ID",
    "nodeIds_other": "Node IDs",
    "canvasAndNodeIds_one": "Canvas & node ID",
    "canvasAndNodeIds_other": "Canvas & node IDs"
  },
  "canvasUi": {
    "hiddenHint": "Interface hidden. Press {{key}} to bring it back."
  },
  "auth": {
    "signedOut": "You have been signed out",
    "signOutFailed": "Error signing out"
  },
  "sync": {
    "edgePoints": "Could not save the edge points",
    "nodeSize": "Could not save the node size",
    "nodePosition": "Could not save the node position",
    "frameResize": "Could not resize the frame",
    "arrange": "Could not arrange the nodes",
    "delete": "Could not delete these elements"
  },
  "arrange": {
    "left": "Align left",
    "hcenter": "Align horizontal centers",
    "right": "Align right",
    "top": "Align top",
    "vcenter": "Align vertical centers",
    "bottom": "Align bottom",
    "distributeH": "Distribute horizontally",
    "distributeV": "Distribute vertically",
    "tidy": "Tidy up"
  },
  "tasks": {
    "clearFailed": "Could not clear this task.",
    "undoFailed": "Could not undo."
  },
  "upload": {
    "failed": "Upload failed"
  },
  "usage": {
    "periodDays_one": "{{count}} day",
    "periodDays_other": "{{count}} days",
    "periodMonths_one": "{{count}} month",
    "periodMonths_other": "{{count}} months"
  },
  "voiceMemo": {
    "saveFailed": "The voice memo could not be saved.",
    "unavailable": "Audio recording is not available."
  },
  "layering": {
    "front": "Bring to front",
    "forward": "Bring forward",
    "backward": "Send backward",
    "back": "Send to back"
  },
  "presence": {
    "someone": "Someone"
  },
  "pdf": {
    "page": "Page {{page}}"
  },
  "runStatus": {
    "running": {
      "label": "In progress",
      "description": "Nolë is working on this conversation."
    },
    "waiting": {
      "label": "Needs your answer",
      "description": "Nolë asked you a question and is waiting for your answer."
    },
    "aborted": {
      "label": "Interrupted",
      "description": "The response was interrupted."
    },
    "error": {
      "label": "Failed",
      "description": "The last response failed."
    },
    "done": {
      "label": "Finished",
      "description": "Nolë has finished this task."
    }
  },
  "embeds": {
    "googleDocs": "Edit a document right on the canvas.",
    "googleSheets": "Edit a spreadsheet right on the canvas.",
    "googleSlides": "Edit a presentation right on the canvas.",
    "googleForms": "Fill in a form without leaving the canvas.",
    "googleDrive": "Preview a Drive file (PDF, image, video…).",
    "figma": "A live design file, FigJam board or prototype.",
    "youtube": "Play a video or a playlist.",
    "vimeo": "Play a video, private links included.",
    "loom": "Play a screen recording.",
    "spotify": "A track, album, playlist or podcast."
  }
}
